import { FieldErrors, useFormContext } from 'react-hook-form'
import { BefehlFormAuftrag } from '../Generic'
import { useTranslation } from 'react-i18next'
import { Befehl24FormData } from './schema/befehl24-form.schema'
import { useEffect } from 'react'

export interface Auftrag24_20_30FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings: boolean
  errors?: FieldErrors
}

export default function Auftrag24_20_30Form({
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings
}: Readonly<Auftrag24_20_30FormProps>) {
  const { t } = useTranslation('ui-befehle')

  const { watch, setValue } = useFormContext<Befehl24FormData>()

  const auftrag_24_20_enabled = watch('auftrag_24_20.enabled')
  const auftrag_24_30_enabled = watch('auftrag_24_30.enabled')

  useEffect(() => {
    if (auftrag_24_20_enabled) {
      setValue('auftrag_24_30.enabled', false)
    }
  }, [auftrag_24_20_enabled, setValue])

  useEffect(() => {
    if (auftrag_24_30_enabled) {
      setValue('auftrag_24_20.enabled', false)
    }
  }, [auftrag_24_30_enabled, setValue])

  return (
    <div className="flex flex-wrap pt-2 gap-2 border-t border-cool-gray-200 items-baseline">
      <BefehlFormAuftrag
        auftragKennung={`24.20`}
        fieldName="auftrag_24_20.enabled"
        readOnly={readOnly}
        testId={`${testId}-auftrag-24-20`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      >
        <div
          className="flex items-baseline gap-2"
          data-testid={`${testId}-auftrag-24-20-text`}
        >
          {t('auftraege.24_20.label')}
        </div>
      </BefehlFormAuftrag>
      <BefehlFormAuftrag
        auftragKennung={`24.30`}
        fieldName="auftrag_24_30.enabled"
        readOnly={readOnly}
        testId={`${testId}-auftrag-24-30`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      >
        <div
          className="flex items-baseline gap-2"
          data-testid={`${testId}-auftrag-24-30-text`}
        >
          {t('auftraege.24_30.label')}
        </div>
      </BefehlFormAuftrag>
    </div>
  )
}
